import { render, staticRenderFns } from "./ActivityTemplatePage.vue?vue&type=template&id=31a3b95e&scoped=true"
import script from "./ActivityTemplatePage.vue?vue&type=script&lang=js"
export * from "./ActivityTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./ActivityTemplatePage.vue?vue&type=style&index=0&id=31a3b95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a3b95e",
  null
  
)

export default component.exports